// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tooltip[data-v-24a238d0]{width:180px;color:#00475a;display:block;margin:0}.portal-deep-blue-bg[data-v-24a238d0]{height:40px;color:#fff;font-size:14px;padding-top:3px}b[data-v-24a238d0],span[data-v-24a238d0]{color:#00475a;font-size:12px;margin:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
